import { WOW } from "wowjs";

import Cookies from "js-cookie";

(function ($) {
    $(document).ready(function () {
        const wow = new WOW();

        wow.init();

        $(".menu-item-has-children")
            .find(".dropdown-toggle")
            .attr("data-toggle", "");

        let body = $("body");
        let desktopMenuBreakpoint = parseInt(
            $(":root").css("--desktop-menu-breakpoint")
        );

        /**
         * Form - Remove .screen-reader-text from time field AM/PM drop down
         */
        $('.gfield_time_ampm label').removeClass('screen-reader-text');

        /**
         * Header - add AODA attributes to the menus
         */
        $('.primary-menu-wrap > ul').attr('aria-label', 'Primary Navigation');
        $('.secondary-menu-wrap > ul').attr('aria-label', 'Secondary Navigation');
        $('ul.bmp-menu').attr('aria-label', 'Portal Navigation');

        /**
         * Header - Search bar functionality
         */
        let searchButton = $(".js-header-search-btn");
        let closeButton = $("#close-button");
        let searchBar = $("#search-container");

        // Search click
        $.each(searchButton, function () {
            $(this).on("click", function () {
                searchBar.fadeIn().addClass("show");
            });
        });

        // Close click
        closeButton.on("click", function () {
            searchBar.fadeOut().removeClass("show");
        });

        /**
         * Social slider
         */
        $.each(
            $(".social-slider-block .social-slider"),
            function (index, slider) {
                var sliderID = "#" + $(slider).attr("id");
                /*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
                $(this).on("slide.bs.carousel", function (e) {
                    var $e = $(e.relatedTarget);
                    var idx = $e.index();
                    var itemsPerSlide = 6;
                    var totalItems = $(sliderID + " .carousel-item").length;

                    if (idx >= totalItems - (itemsPerSlide - 1)) {
                        var it = itemsPerSlide - (totalItems - idx);
                        for (var i = 0; i < it; i++) {
                            // append slides to end
                            if (e.direction === "left") {
                                $(sliderID + " .carousel-item")
                                    .eq(i)
                                    .appendTo(sliderID + " .carousel-inner");
                            } else {
                                $(sliderID + " .carousel-item")
                                    .eq(0)
                                    .appendTo(sliderID + " .carousel-inner");
                            }
                        }
                    }
                });
            }
        );

        /**
         * Post slider
         */
        $.each($(".post-slider-block .post-slider"), function (index, slider) {
            var sliderID = "#" + $(slider).attr("id");
            /*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
            $(this).on("slide.bs.carousel", function (e) {
                var $e = $(e.relatedTarget);
                var idx = $e.index();
                var itemsPerSlide = 5;
                var totalItems = $(sliderID + " .carousel-item").length;

                if (idx >= totalItems - (itemsPerSlide - 1)) {
                    var it = itemsPerSlide - (totalItems - idx);
                    for (var i = 0; i < it; i++) {
                        // append slides to end
                        if (e.direction === "left") {
                            $(sliderID + " .carousel-item")
                                .eq(i)
                                .appendTo(sliderID + " .carousel-inner");
                        } else {
                            $(sliderID + " .carousel-item")
                                .eq(0)
                                .appendTo(sliderID + " .carousel-inner");
                        }
                    }
                }
            });
        });

        /**
         * Social Slider - Link functionality
         */
        $.each(
            $(
                ".social-slider-block .carousel .carousel-inner .carousel-item .social-item"
            ),
            function () {
                let postLink = $(this).attr("data-link");

                $(this).on("click", function () {
                    window.open(postLink, "_blank").focus();
                });
            }
        );

        /**
         * Sticky call section
         */
        // const stickyElm = document.getElementById('call-us');
        // const observer = new IntersectionObserver(
        // 	([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
        // 	{threshold: [1]}
        // );
        // observer.observe(stickyElm);

        /**
         * Navbar height
         */
        let calculateNavbarHeight = function () {
            let navbarHeight = 0;

            $("body > header")
                .children()
                .each(function () {
                    navbarHeight += $(this).outerHeight();
                });

            $("body > header").css(
                "--header-navbar-height",
                navbarHeight + "px"
            );
        };

        /**
         * Testimonial - Set equal heights
         */
        function testimonialEqualHeights() {
            $(".testimonial-large-block, .testimonial-block").each(function () {
                var items = $(".carousel-item", this);
                let maxHeight = 0;

                // Show all slides
                $.each(items, function (i, slide) {
                    $(slide).addClass("active");
                });

                // Get the height of the tallest caption and save it
                $.each(items, function () {
                    let caption = $(".card-body", this);
                    let captionHeight = caption.outerHeight();

                    if (captionHeight > maxHeight) {
                        maxHeight = captionHeight;
                    }
                });

                // Apply the max height to all captions
                $.each(items, function () {
                    let caption = $(".card-body", this);
                    caption.css("height", maxHeight);

                    // Remove .active from all slides
                    $(this).removeClass("active");
                });

                // Add the active class back to the first slide
                $(
                    ".testimonial-large-block .carousel-inner .carousel-item:first-of-type, .testimonial-block .carousel-inner .carousel-item:first-of-type"
                ).addClass("active");
            });
        }

        // Run equal heights
        testimonialEqualHeights();

        /**
         * Carousel - Set equal heights to captions on mobile
         */
        let equalCarouselSlideHeights = function (carouselSelector) {
            $(carouselSelector).each(function () {
                var items = $(".carousel-item", this);
                let maxHeight = 0;

                // Show all slides
                $.each(items, function (i, slide) {
                    $(this).css("height", "");
                    $(".carousel-caption", this).css("height", "");

                    $(slide).addClass("active");
                });

                // Get the height of the tallest caption and save it
                $.each(items, function () {
                    let caption = $(".carousel-caption", this);
                    let captionHeight = caption.outerHeight();

                    if (captionHeight > maxHeight) {
                        maxHeight = captionHeight;
                    }
                });

                // Apply the max height to all captions
                $.each(items, function () {
                    if (
                        $(window).width() >=
                        parseInt($(":root").css("--breakpoint-lg"))
                    ) {
                        $(this).css("height", maxHeight);
                    } else {
                        $(".carousel-caption", this).css("height", maxHeight);
                    }

                    // Remove .active from all slides
                    $(this).removeClass("active");
                });

                // Add the active class back to the first slide
                $(
                    ".carousel-inner .carousel-item:first-of-type",
                    this
                ).addClass("active");
            });
        };

        equalCarouselSlideHeights(
            ".carousel-block .carousel, .spotlight-carousel-block .spotlight-text-carousel"
        );

        let resizeThrottled = false;

        $(window).on("resize", function () {
            if (!resizeThrottled) {
                calculateNavbarHeight();
                equalCarouselSlideHeights(".carousel-block .carousel, .spotlight-carousel-block .spotlight-text-carousel");
                testimonialEqualHeights();

                /**
                 * Disabled to prevent automatic jump to first slide on mobile scroll
                 */
                // equalCarouselSlideHeights(
                //     ".carousel-block .carousel, .spotlight-carousel-block .spotlight-text-carousel"
                // );

                resizeThrottled = true;

                setTimeout(function () {
                    resizeThrottled = false;

                    calculateNavbarHeight();
                }, 100);
            }
        });

        /**
         * Back to top button - scroll functionality
         */
        $("#back-to-top").on("click", function () {
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                400
            );

            return false;
        });

        /**
         * Copyright - Display current year
         */
        let copyrightYear = new Date().getFullYear();
        $("#copyright-year").text(copyrightYear);

        /**
         * Add class to body when sticky header is showing
         */
        if ($(window).scrollTop() > 100) {
            body.addClass("sticky-header");
            $("header").addClass("sticky");
        } else {
            body.removeClass("sticky-header");
            $("header").removeClass("sticky");
        }
        $(window).scroll(function () {
            if ($(window).scrollTop() > 100) {
                $("body").addClass("sticky-header");
                $("header").addClass("sticky");
            } else {
                $("body").removeClass("sticky-header");
                $("header").removeClass("sticky");
            }
        });

        let headerHeight = $("header").height();

        if ($(window).scrollTop() > 100) {
            $("body header").addClass("sticked").css("position", "fixed");
            $("#content").css("padding-top", headerHeight);
        } else {
            $("body header").removeClass("sticked").css("position", "sticky");
            $("#content").css("padding-top", 0);
        }
        $(window).scroll(function () {
            if ($(window).scrollTop() > 100) {
                $("body header").addClass("sticked").css("position", "fixed");
                $("#content").css("padding-top", headerHeight);
            } else {
                $("body header")
                    .removeClass("sticked")
                    .css("position", "sticky");
                $("#content").css("padding-top", 0);
            }
        });

        /**
         * Mobile menu
         */

        $("header .js-mobile-menu-toggle").on("click", function () {
            $("body").toggleClass("no-scroll");
            searchBar.fadeOut().removeClass("show");
        });

        $("#header-navbar-menu-wrapper")
            .find(
                ".navbar-nav .menu-item.menu-item-has-children > .dropdown-menu"
            )
            .each(function () {
                if ($(window).width() < desktopMenuBreakpoint) {
                    $(this).addClass("mobile-menu-sub-level-panel");

                    let subLevelTitleElement = $("<h3>").html(
                        $(this).siblings(".nav-link").html().trim()
                    );

                    $(this).prepend(
                        $("<li>")
                            .addClass("menu-item sub-level-panel-heading")
                            .append(subLevelTitleElement)
                    );
                }
            });

        $("#header-navbar-menu-wrapper.navbar-collapse")
            .on("show.bs.collapse", function () {
                let headerBannerHeight = 0;

                $("body > header")
                    .children()
                    .each(function () {
                        headerBannerHeight += $(this).outerHeight();
                    });

                if (!$("body > header").hasClass("sticky")) {
                    headerBannerHeight +=
                        parseInt($("html").css("margin-top")) -
                        $("html").scrollTop();
                }

                $(this).css(
                    "--mobile-menu-height",
                    $(window).outerHeight() - headerBannerHeight + "px"
                );

                $(this)
                    .children(".header-navbar-menu-inner-wrap")
                    .addClass("curr-level");
            })
            .on("hidden.bs.collapse", function () {
                $(this).find(".curr-level").removeClass("curr-level");

                $(this).find(".show").removeClass("show fade-in");

                $(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

                $(this).find(".js-menu-back-btn").data("depth-level", 0);
            });

        let mobileMenuBackBtnWrap = $("#header-navbar-menu-wrapper").find(
            ".back-btn-wrap"
        );
        let mobileMenuBackBtn =
            mobileMenuBackBtnWrap.children(".js-menu-back-btn");

        mobileMenuBackBtn.data("depth-level", 0);

        mobileMenuBackBtn.on("click", function () {
            $(this).data("depth-level", $(this).data("depth-level") - 1);

            let currentMenuPanel = $("#header-navbar-menu-wrapper").find(
                ".mobile-menu-sub-level-panel.curr-level"
            );

            currentMenuPanel
                .parent()
                .closest(".mobile-menu-sub-level-panel")
                .addClass("curr-level");

            currentMenuPanel
                .addClass("fade-out")
                .removeClass("show fade-in curr-level");

            if ($(this).data("depth-level") <= 0) {
                $("#header-navbar-menu-wrapper")
                    .find(".header-navbar-menu-inner-wrap")
                    .addClass("curr-level");

                $(this)
                    .data("depth-level", 0)
                    .parent()
                    .addClass("fade-out")
                    .removeClass("show fade-in");
            }
        });

        $("#header-navbar-menu-wrapper")
            .find(".navbar-nav .menu-item.menu-item-has-children > .nav-link")
            .on("click", function (evt) {
                evt.preventDefault();

                $("#header-navbar-menu-wrapper")
                    .find(".curr-level")
                    .removeClass("curr-level");

                $(this)
                    .siblings(".mobile-menu-sub-level-panel")
                    .scrollTop(0)
                    .removeClass("fade-out")
                    .addClass("show fade-in curr-level");

                if (window.innerWidth < 992) {
                    if (mobileMenuBackBtn.data("depth-level") === 0) {
                        mobileMenuBackBtnWrap
                            .removeClass("fade-out")
                            .addClass("show fade-in");
                    } else {
                        $(this)
                            .siblings(".mobile-menu-sub-level-panel")
                            .css(
                                "top",
                                $(this)
                                    .closest(
                                        ".mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap"
                                    )
                                    .scrollTop()
                            );
                    }
                }

                mobileMenuBackBtn.data(
                    "depth-level",
                    mobileMenuBackBtn.data("depth-level") + 1
                );

                return false;
            });

        /**
         * Language selector modal
         */
        if (Cookies.get("cas-user-selected-language") == null) {
            $("#language-selector-modal").modal("show");
        }

        $("#language-selector-modal").on(
            "click",
            ".btn-language-selector",
            function (evt) {
                let selectedLangBtn = $(this);

                let currWordpressLang = Cookies.get("wp-wpml_current_language");

                if (
                    selectedLangBtn.get(0).hasAttribute("data-language-code") &&
                    selectedLangBtn.data("language-code") !== ""
                ) {
                    // Save user's selected language as a cookie
                    Cookies.set(
                        "cas-user-selected-language",
                        selectedLangBtn.data("language-code")
                    );

                    // If the language of the loaded page matches the user's selected language, we just need to close the modal instead of refreshing the page.
                    if (
                        selectedLangBtn.data("language-code") ===
                        currWordpressLang
                    ) {
                        // Stop the page from refreshing
                        evt.preventDefault();

                        let languageModal = $(evt.delegateTarget);

                        // Close the modal
                        languageModal.modal("hide");

                        // Make double sure the page won't refresh
                        return false;
                    }
                }

                // Continue with the normal button action and navigate to the site's homepage with the desired language set.
                return true;
            }
        );

        // Detect when clicks language switcher link to explicitly change their selected language, and update the cookie value
        $(".wpml-ls-link").on("click", function () {
            // Get the code of the language the user wants to switch to
            // Sanitize value since it's from and HTML element
            let switchedToLangCode = $(this)
                .find(".wpml-ls-native")
                .attr("lang")
                .toLowerCase()
                .replace(/[^a-z]/g, "");

            Cookies.set("cas-user-selected-language", switchedToLangCode);
        });
    });
})(jQuery);
